import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import * as Common from '_common';
import * as Components from '_components';
import * as Utils from '_utils';
import * as Styles from './SimpleComponents.module.scss';
// export function Cmd(component: Common.IComponent, index?: number): React.ReactNode { }
export function Article(component, index) {
    return (_jsxs("article", { className: component.properties.type, children: [component.properties.hideHeader || _jsx(ArticleHeader, {}), _jsx(Components.SimpleComponentContent, { component: component })] }, index));
}
export function IfRender(component, index) {
    return (_jsx(If, { role: component.properties.role, culture: component.properties.culture, children: Components.RenderChildren(component.children) }, index));
}
export function If(props) {
    const language = Common.useLanguage();
    const user = Common.useUser();
    if (props.culture && props.culture !== language) {
        return [];
    }
    if (props.role && !Common.userHaveRole(user, props.role)) {
        return [];
    }
    return props.children;
}
export function ArticleContent(component, index) {
    // TODO styles
    return (_jsx("div", { className: "content", children: _jsx(Components.SimpleComponentContent, { component: component }) }, index));
}
export function ArticleHeader() {
    return (_jsx(_Fragment, { children: _jsx("hr", {}) }));
}
export function Section(component, index) {
    return (_jsx("section", { children: _jsx(Components.SimpleComponentContent, { component: component }) }, index));
}
export function List(component, index) {
    return (_jsx("ul", { children: _jsx(Components.SimpleComponentContent, { component: component }) }, index));
}
export function Item(component, index) {
    return (_jsx("li", { children: _jsx(Components.SimpleComponentContent, { component: component }) }, index));
}
export function Details(component, index) {
    // TODO styles
    return (_jsx("div", { className: "details", children: _jsx(Components.SimpleComponentContent, { component: component }) }, index));
}
export function VersionInfoRender(component, index) {
    return _jsx(VersionInfo, {}, index);
}
export function VersionInfo() {
    return _jsx("span", { children: document.appVersion });
}
export function MLTRender(component, index) {
    return _jsx(Common.MLT, { cs: component.properties?.cs, en: component.properties?.en });
}
export function PropertyRender(component, index) {
    return (_jsx(Property, { title: MLTRender(component), children: _jsx(Components.SimpleComponentContent, { component: component }) }));
}
export function Property(props) {
    return (_jsx("div", { className: Styles.container, children: _jsxs("div", { className: Styles.property, children: [!props.hideTitle && props.title && (_jsxs(_Fragment, { children: [_jsx("label", { children: props.title }), _jsx("span", { className: Styles.delimiter, children: ":" })] })), _jsx("span", { className: Styles.value, children: props.children })] }) }));
}
export function Hr(component, index) {
    return _jsx("hr", {});
}
export function CodeRender(component, index) {
    return (_jsx(Components.Code, { type: component.properties?.type ?? component.properties?.lang, source: component.properties?.text }));
}
export function Container(props) {
    let classNames = {};
    classNames = Components.WithTileProps(props, classNames);
    const classes = Utils.classNames(classNames);
    return (_jsx(Common.Component, { name: "container", className: classes, children: props.children }));
}
export function ListBullet() {
    return _jsx("span", { className: Styles.bullet, children: " " });
}
export function ErrorPanel(props) {
    return (_jsxs("div", { className: Styles.errorPanel, children: [_jsx("h1", { children: props.title ?? 'Error' }), props.children && (_jsxs(_Fragment, { children: [_jsx("hr", {}), _jsx("pre", { children: props.children }), ' '] }))] }));
}
export function ErrorRender(component, index) {
    return (_jsx(ErrorPanel, { title: component.properties?.title, children: component.properties?.text }, index));
}
export function WarningPanel(props) {
    return (_jsxs("div", { className: Styles.warningPanel, children: [_jsx("h1", { children: props.title ?? 'Warning' }), props.children && (_jsxs(_Fragment, { children: [_jsx("hr", {}), _jsx("pre", { children: props.children }), ' '] }))] }));
}
export function WarningRender(component, index) {
    return (_jsx(WarningPanel, { title: component.properties?.title, children: component.properties?.text }, index));
}
